import React from 'react';
import { MoneyInput } from '@atlas/ui';

import { useApplicationState } from '@atlas/core';

import Field from 'common/Form/Field';

export default function MoneyField({ field, onChange, onFocus, onBlur }) {
  const {
    touched,
    value,
    autofocus,
    disabled,
    active,
    label,
    placeholder,
    name,
    errors,
    className,
    uiTitleClassName,
    amountIcon,
  } = field;

  const { wallet } = useApplicationState();

  const error = touched && errors[0];
  const success = touched && !error;

  return (
    <Field options={field}>
      <MoneyInput
        name={name}
        error={error}
        currency={wallet.currency}
        label={label}
        value={value}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
        autoFocus={autofocus}
        touched={touched}
        active={active}
        disabled={disabled}
        success={success}
        className={className}
        uiTitleClassName={uiTitleClassName}
        amountIcon={amountIcon}
      />
    </Field>
  );
}
